<template>
  <transition name="fade-in" appear>
    <div
      :style="{ zIndex: updatePlateClicked ? 9999 : 99999 }"
      class="modal fade-in"
      v-show="mostrarModal"
      v-async="loading"
    >
      <div class="modal-content">
        <div class="modal-header">
          <span
            class="close"
            @click="fecharModal()"
            style="position: absolute; top: 10px; right: 10px"
            >&times;</span
          >
          <div class="header-content">
            <h2>Placa do veículo - Confira as informações</h2>
          </div>
        </div>
        <div class="modal-body">
          <div class="labelContainer">
            <label>Formato Antigo</label>
            <label>Padrão Mercosul</label>
          </div>
          <div class="plate-container">
            <input
              disabled
              class="input-old"
              id="oldPlate"
              v-model="oldPlate"
              v-only-numbers
              maxlength="8"
            />
            <input
              disabled
              autocomplete="off"
              class="input-new"
              id="newPlate"
              v-model="newPlate"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button class="cancel-button" @click="fecharModal()">Cancelar</button>
          <button class="confirm-button" @click="doUpdatePlate()">
            Confirmar mudança
          </button>
        </div>
        <loadingV2 v-if="loading"> </loadingV2>
      </div>
    </div>
  </transition>
</template>

<script>
import vehicle from "../services/vehicles";
export default {
  props: {
    plateToConvert: undefined,
  },
  data() {
    return {
      mostrarModal: true,
      newPlate: undefined,
      oldPlate: undefined,
      successConverted: undefined,
      loading: false,
      updatePlateClicked: false, // Adiciona esta linha
    };
  },

  mounted() {
    this.oldPlate = this.plateToConvert;

    vehicle.getVehicleMercosulPlate(this.plateToConvert).then((res) => {
      this.newPlate = res;
    });
  },

  methods: {
    doUpdatePlate() {
      this.updatePlateClicked = true; // Adiciona esta linha
      this.loading = true;
      vehicle
        .alterToMercosulPlate(this.oldPlate)
        .then((res) => {
          if (res.status.code == 0) {
            this.successConverted = 1;
            this.$emit("fechar");
            this.$emit("success", this.successConverted);
          } else {
            this.successConverted = 0;
            this.$emit("fechar");
            this.$emit("error", this.successConverted);
          }
        })
        .catch((err) => {
          this.successConverted = 0;
          this.$emit("fechar");
          this.$emit("error", this.successConverted);
        });
    },
    fecharModal() {
      const modal = document.querySelector(".modal");
      modal.classList.add("fade-out");
      modal.classList.remove("fade-in");

      modal.addEventListener("animationend", () => {
        this.$emit("fechar");
        this.mostrarModal = false;
      });
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  margin-top: -135px;
}

.modal-content {
  background-color: #fff;
  width: 523px;
  /* padding: 20px; */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  border-radius: 10px; /* Adiciona bordas arredondadas à modal */
}

.modal-header {
  background: #613a7d;
  color: white;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  margin-bottom: 20px;
  border-radius: 4px;
}

.modal-header h2 {
  margin: 0;
}

h2 {
  color: #fff;
  font-family: Open Sans;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: left;
}

.header-content {
  margin-left: 26px;
}

.close {
  font-size: 24px;
  cursor: pointer;
  width: 24px;
  height: 24px;
}
.modal-body {
  padding: 0px;
}

.modal-footer {
  padding: 13px;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.cancel-button {
  display: flex;
  width: 192px;
  height: 38px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 40px;
  border: none;
  color: var(--primary-light, #5d3b81);
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  background-color: white;
  margin-left: -23px;
}

.confirm-button {
  display: flex;
  width: 192px;
  height: 38px;
  padding: 8px 14px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  border-radius: 40px;
  border: 1px solid var(--primary-light, #5d3b81);
  background: var(--primary-light, #5d3b81);
  color: var(--primary-contrast, #fff);
  text-align: center;
  font-family: Open Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-left: 91px;
}

.fade-in {
  animation: fadeIn 0.4s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fade-out {
  animation: fadeOut 0.2s ease;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.labelContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.plate-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  margin-top: 20px;
}

.input-old {
  width: 132px;
  height: 46px;
  flex-shrink: 0;
  margin-right: 121px; /* Adicione margem entre os inputs */
  margin-left: 50px;
  border-radius: 7.253px;
  border: 1.451px solid #d0d0d0;
  background: #e1e1e1;
  color: #252525;
  font-family: Open Sans;
  font-size: 21.758px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
.input-new {
  width: 132px;
  height: 46px;
  flex-shrink: 0;
  margin-right: 138px; /* Adicione margem entre os inputs */
  margin-left: 7px;
  border-radius: 7.253px;
  border: 1.451px solid #d0d0d0;
  background: #e1e1e1;
  color: #252525;
  font-family: Open Sans;
  font-size: 21.758px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}

label {
  margin-right: 95px;
  margin-left: 56px;
  color: #252525;
  font-family: Open Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: -4px;
}

@media (max-width: 500px) {
  .modal-content {
    width: 412px;
  }

  .input-old {
    margin-right: 43px;
  }

  .confirm-button {
    width: 184px;
    margin-left: 17px;
  }

  label {
    margin-right: 55px;
    margin-left: 45px;
  }
}

@media (max-width: 400px) {
  .modal-content {
    width: 358px;
  }

  .input-old {
    margin-left: 31px;
    margin-right: 43px;
  }
  .input-new {
    margin-left: -21px;
  }

  .confirm-button {
    width: 184px;
    margin-left: -36px;
  }

  .cancel-button {
    margin-left: -20px;
  }

  label {
    margin-left: 27px;
    margin-right: 46px;
  }
}

@media (max-width: 360px) {
  .modal-content {
    width: 358px;
  }

  .input-old {
    margin-left: 31px;
    margin-right: 43px;
  }
  .input-new {
    margin-left: -21px;
  }

  .confirm-button {
    width: 184px;
    margin-left: -36px;
  }

  .cancel-button {
    margin-left: -20px;
  }

  label {
    margin-left: 27px;
    margin-right: 46px;
  }
}

@media (width: 1366px) {
  .modal {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// modal-switch-plate.vue?0565f76e